module.exports = __webpack_public_path__ + "img/nomad3.18a38788.jpg";